import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center" }
const _hoisted_2 = { class: "is-flex is-flex-direction-row is-justify-content-start is-align-items-center" }
const _hoisted_3 = ["data-tooltip"]
const _hoisted_4 = { class: "is-flex is-flex-direction-row is-justify-content-end is-align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-map-marker" }, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-battery" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-refresh mr-2" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!
  const _component_station_export_modal = _resolveComponent("station-export-modal")!
  const _component_station_edition_modal = _resolveComponent("station-edition-modal")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('onStationClicked', _ctx.station))),
    class: _normalizeClass(["box w-100 mb-2 p-2", { 'is-active': _ctx.active }]),
    key: _ctx.station.id,
    ref: `station-${_ctx.station.id}`
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_n_checkbox, {
          checked: _ctx.isActive,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isActive) = $event)),
          class: "mr-2"
        }, null, 8 /* PROPS */, ["checked"]),
        _createElementVNode("span", {
          class: "has-text-weight-bold has-text-link has-first-letter-uppercase has-tooltip-bottom mr-2",
          "data-tooltip": _ctx.station.name
        }, _toDisplayString(_ctx.getStationName(_ctx.station)), 9 /* TEXT, PROPS */, _hoisted_3),
        _createElementVNode("span", {
          class: _normalizeClass(["dot mr-2 h-100", { 'is-success': _ctx.station.status === 'online', 'is-danger': _ctx.station.status === 'offline' }])
        }, null, 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.favorites?.includes(_ctx.station.id))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "mdi mdi-star has-text-success is-size-5 is-hoverable",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeFavoriteStation($event, _ctx.station)))
            }))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "mdi mdi-star-outline has-text-success is-size-5 is-hoverable",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addFavoriteStation($event, _ctx.station)))
            }))
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_5,
      _createElementVNode("span", null, _toDisplayString(_ctx.station.metadata && _ctx.station.metadata['elichens/public/locality_long'] ?
                    _ctx.station.metadata['elichens/public/locality_long'] : '-'), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_ctx.station.latest_values ? _ctx.station.latest_values.SOC : '--') + "%", 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", {
          class: _normalizeClass(["mdi mr-2", { 'mdi-wifi-strength-4': _ctx.station.status === 'online', 'mdi-wifi-strength-off': _ctx.station.status === 'offline', 'has-text-danger': _ctx.station.status === 'offline' }])
        }, null, 2 /* CLASS */),
        _createElementVNode("span", null, _toDisplayString(_ctx.station.status === 'online' ? _ctx.$t('global.connected') : _ctx.$t('global.disconnected')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_ctx.moment.unix(_ctx.station.last_seen).fromNow()), 1 /* TEXT */)
      ]),
      _createVNode(_component_n_dropdown, {
        show: _ctx.show,
        "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.show) = $event)),
        options: _ctx.options,
        trigger: "manual",
        onSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSelect($event, _ctx.station))),
        onClickoutside: _cache[6] || (_cache[6] = ($event: any) => (_ctx.show=!_ctx.show)),
        "render-icon": _ctx.renderDropdownIcon,
        "render-label": _ctx.renderLabel,
        "show-arrow": true,
        placement: 'bottom-end'
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDropdownButtonClick && _ctx.handleDropdownButtonClick(...args))),
            class: "is-size-4 mdi mdi-dots-vertical"
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show", "options", "render-icon", "render-label"])
    ]),
    (_ctx.station)
      ? (_openBlock(), _createBlock(_component_station_export_modal, {
          key: 0,
          ref: "exportModal",
          station: _ctx.station
        }, null, 8 /* PROPS */, ["station"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_station_edition_modal, {
      ref: "stationEditionModal",
      "onStation:edit": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('station:edit')))
    }, null, 512 /* NEED_PATCH */)
  ], 2 /* CLASS */))
}